import { render, staticRenderFns } from "./PrintHistoryCard.vue?vue&type=template&id=27494670&"
import script from "./PrintHistoryCard.vue?vue&type=script&lang=ts&"
export * from "./PrintHistoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports